import { roundNumber } from '@hotjar/insights-common/lib/number';
import { tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import type { NPSGraphResolution } from '@hotjar/webapp/features/Surveys/Results/NPSLineChartWithResolution/resolutions';
import { formatDateForResolution } from '@hotjar/webapp/features/Surveys/Results/NPSLineChartWithResolution/resolutions';
import { useTranslation } from '@hotjar/translations';

const Container = styled.div`
  ${tokens.text('body2')};
  color: ${tokens.color.text_default_inverse};
  background-color: ${tokens.color.neutral_800};
  border-radius: ${tokens.radius.m};
  ${tokens.elevation(1)};
  padding: ${tokens.spacer.x1};
  white-space: nowrap;
  display: flex;
  align-items: center;
  flex-direction: column;
`;
const DateText = styled.span`
  ${tokens.text('subtitle2')};
`;
const Score = styled.span`
  ${tokens.text('header5')};
  margin-top: ${tokens.spacer.x1};
`;
const Caption = styled.span`
  ${tokens.text('caption')};
  color: ${tokens.color.text_light_inverse};
  margin-top: ${tokens.spacer.x0};
`;

export interface NPSChartTooltipProps {
  sampleDate: Date;
  score: number;
  resolution: NPSGraphResolution;
  dateRangeInDays: number;
}

export const NPSChartTooltip = ({
  sampleDate,
  score,
  resolution,
  dateRangeInDays,
}: NPSChartTooltipProps): JSX.Element => {
  const { t } = useTranslation('feedback', { keyPrefix: 'results.nps-view-mode' });
  return (
    <Container>
      <DateText>{formatDateForResolution(sampleDate, resolution, dateRangeInDays > 180)}</DateText>
      <Score>{roundNumber(score, 1)}</Score>
      <Caption>{t(sampleDate > new Date() ? 'overall-nps-projected' : 'overall-nps')}</Caption>
    </Container>
  );
};
